/* global $ */

var StickyTableHeader = function () {
  var self = this
  this.width = 768
  const stickyHeader = $('#table--sticky--header')

  console.info('Run StickyTableHeader ...')

  this.run = function () {
    if (self.width < window.outerWidth && stickyHeader.length) {
      stickyHeader.stickyTableHeaders()
    } else {
      stickyHeader.stickyTableHeaders('destroy')
    }
  }

  this.run()
  window.addEventListener('resize', this.run)
}

module.exports = {
  StickyTableHeader: StickyTableHeader
}
